import { Divider } from 'antd'
import React from 'react'

import { useIsRootAdmin, useIsSystemAdmin } from '@/modules/admin/admin.hooks'

import { AdminRoot } from './admin-root.component'
import { FeatureToggleComponent } from './feature-toggle.component'

export const AdminRootContainer = () => {
  const isRootAdmin = useIsRootAdmin()
  const isSystemAdmin = useIsSystemAdmin()

  if (!isRootAdmin && !isSystemAdmin) {
    return null
  }

  return (
    <div style={{ display: 'flex' }}>
      {isRootAdmin && <AdminRoot />}
      <Divider style={{ height: '100vh' }} type='vertical' />
      <FeatureToggleComponent />
    </div>
  )
}
